import { rangeNumbers } from 'utils/combineAges';
import { formatGroupHeading } from 'utils/groupLabel';

// The ages the Add Club Record dialog offers: every single age the club's own
// visible age groups cover, lowest first, each labelled as the club reads it
// in a list ("U11", "11" in an Age organisation, "Y6" in a school by year). A
// record is always for one age, so a group "U14-U17" offers U14, U15, U16 and
// U17. Nothing the club does not have: the dialog's fixed list offered 5 to
// 20, Senior and Masters to every club (Doug, 2026-10-23). A group whose range
// cannot be read is left out.
export const clubRecordAgeOptions = (ageGroups, groupingBasis) => {
  const numbers = new Set();
  (ageGroups || [])
    .filter((group) => group.isVisible !== false)
    .forEach((group) => {
      (rangeNumbers(group.ageRange) || []).forEach((number) => numbers.add(number));
    });
  return [...numbers]
    .sort((a, b) => a - b)
    .map((number) => ({
      value: String(number),
      label: formatGroupHeading(groupingBasis, number),
    }));
};
